import React from 'react';
import { UsersIcon } from 'lucide-react';
interface ScarcityBarProps {
  spotsLeft?: number;
  percentTaken?: number;
  note?: string;
}
export function ScarcityBar({
  spotsLeft = 9,
  percentTaken = 93,
  note = 'Once the launch promotion ends, the price may return to the regular price.'
}: ScarcityBarProps) {
  return <div className="w-full rounded-2xl bg-white/10 p-4 ring-1 ring-white/15" data-id="element-32" data-mp="2q2pu4esq972m">
      <div className="flex items-center justify-between gap-3" data-id="element-33" data-mp="2b6gx7jwb75td">
        <span className="flex items-center gap-2 font-display text-[11px] font-bold uppercase tracking-[0.16em] text-brand-100" data-id="element-34" data-mp="2g5tkg5r3eewh">
          <UsersIcon className="h-4 w-4 text-gold-500" aria-hidden="true" data-id="element-35" data-mp="226tvewzo3xzs" />
          Promo price spots
        </span>
        <span className="rounded-full bg-gold-500 px-2.5 py-1 font-display text-[11px] font-black uppercase tracking-wide text-navy-950" data-id="element-36" data-mp="275y3tlerprp2">
          {spotsLeft} left
        </span>
      </div>

      <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-navy-950/60" role="progressbar" aria-valuenow={percentTaken} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-37" data-mp="5cqpae6zbe48">
        <div className="h-full rounded-full bg-gold-500 transition-[width] duration-300 ease-out" style={{
        width: `${percentTaken}%`
      }} data-id="element-38" data-mp="3dcoftd3frc6a" />
      </div>

      <p className="mt-2.5 text-[12px] font-semibold text-white" data-id="element-39" data-mp="38fo9r26l69f6">
        {percentTaken}% of the launch spots are already taken.
      </p>
      <p className="mt-1 text-[11px] leading-relaxed text-brand-100/70" data-id="element-40" data-mp="2gmxg8zgaeytm">{note}</p>
    </div>;
}